export const saveUser = (user) => {
  sessionStorage.setItem("user", JSON.stringify(user));
};

export const getUser = () => {
  const user = sessionStorage.getItem("user");

  if (user) {
    return JSON.parse(user);
  }

  return null;
};

export const getRole = () => {
  const user = getUser();

  return user?.role;
};

export const logout = () => {
  sessionStorage.removeItem("user");
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("userEmail");
};
